import { css } from '@emotion/react';

import { Theme } from '../../theme/types';
import { mediaQueries, breakpoints } from '../../styles/media-queries';

const SCALING_FACTOR = 0.8;

export const glNormalize = (theme: Theme) => css`
  * {
    font-family: ${theme.fontFamily.default};
    font-display: swap;
    box-sizing: border-box;
  }
  html {
    font-size: 16px;
  }
  body {
    overflow-x: hidden;
    margin: 0 auto;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }
  b {
    font-weight: ${theme.fontWeight.bold};
  }

  /* responsive scaling */
  html {
    ${mediaQueries.mobile} {
      font-size: calc(100vw * (16 / ${breakpoints.mobile}));
    }
    ${mediaQueries.tablet} {
      font-size: 16px;
    }
    ${mediaQueries.desktop} {
      font-size: calc(
        16 *
          (
            (100vw + ((${breakpoints.max}px - 100vw) * ${SCALING_FACTOR})) /
              ${breakpoints.max}
          )
      );
    }
    ${mediaQueries.max} {
      font-size: 16px;
    }
  }
`;
